import React, { SyntheticEvent, useEffect, useState, Fragment } from "react";
import {
  StyledNavigation,
  StyledNavigationWrapper,
  StyledNavigationMenus,
  StyledNavigationItem,
  StyledButton,
  StyledLabel,
  StyledMobileMenuWrapper,
  StyledMenuButton,
  StyledHomeButton,
  StyledDivider,
} from "./Navigation.styled";
import { useIsMobileSize } from "../../../hooks/use-is-mobile-size";
import { Menu } from "../../../data/types/Menu";
import { Icon } from "../../general/Icon/Icon";
import { sendEvent } from "../../../helpers/analytics";

export interface NavigationMenu {
  id: string;
  label: string;
}

export interface NavigationProps {
  className?: string;
  navigation: Array<NavigationMenu>;
  activeId?: string;
  setActiveId: (id: Menu) => void;
}

const Navigation: React.FC<NavigationProps> = ({
  navigation,
  activeId = "",
  setActiveId,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobileSize = useIsMobileSize();

  const handleClick = ({ currentTarget }: SyntheticEvent<HTMLElement>) => {
    const id = currentTarget.dataset.navId || "";
    sendEvent({ event: "navigate", navigate: { targetId: id, activeId } });
    setActiveId(id as Menu);
    if (isMobileSize) {
      setIsOpen(false);
    }
  };

  const handleMenuClick = () => {
    sendEvent({ event: "mobilemenu", mobilemenu: { isOpen, activeId } });
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    // Prevent scrolling on menu open
    const originalStyle = window.getComputedStyle(document.body).overflow;
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = originalStyle;
    }

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isOpen]);

  return (
    <>
      <StyledNavigation className={className}>
        <StyledMobileMenuWrapper $isOpen={isOpen}>
          <StyledMenuButton onClick={handleMenuClick} $isOpen={isOpen}>
            <Icon name={isOpen ? "Close" : "Menu"} />
          </StyledMenuButton>
        </StyledMobileMenuWrapper>

        <StyledNavigationWrapper $isOpen={isOpen}>
          <StyledNavigationMenus>
            {navigation.map(({ id, label }, index) => (
              <Fragment key={label}>
                <StyledNavigationItem>
                  <StyledButton
                    onClick={handleClick}
                    data-nav-id={id}
                    $isActive={activeId === id}
                  >
                    <StyledLabel
                      type="span"
                      textTransform="uppercase"
                      $isActive={activeId === id}
                    >
                      {label}
                    </StyledLabel>
                  </StyledButton>
                </StyledNavigationItem>
                {!isMobileSize && index !== navigation.length - 1 && (
                  <StyledDivider name="GlascBug1" />
                )}
              </Fragment>
            ))}
          </StyledNavigationMenus>
          {isMobileSize && (
            <StyledHomeButton onClick={handleClick} $isOpen={isOpen} />
          )}
        </StyledNavigationWrapper>
      </StyledNavigation>
    </>
  );
};

export default Navigation;
